import React from 'react';
import { NavLink } from 'react-router-dom';

var bgimg1 = require('./../../images/background/bg-5.png');
var bgimg2 = require('./../../images/background/bg.jpg');
var bgimg3 = require('./../../images/background/cross-line2.png');
var photo = require('./../../images/Adem.jpeg');
var logo = require('./../../images/logo-1.jpeg');
var sign = require('./../../images/sign.png');




class WhatWeDo1 extends React.Component {
    render() {
        return (
            <>
                <div className="section-full  mobile-page-padding bg-white  p-t80 p-b30 bg-repeat overflow-hide" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                    <div className="container right-half-bg-image-outer">
                        
                        <div className="section-content">
                        
                            <div className="large-title-block full-content bg-gray">
                                <div className="row">
                                    <div className="col-lg-4 col-md-12 col-sm-12 text-center">
                                        <div className="large-title">
                                            <img src={logo} style={{border:1,width:150,height:150, borderRadius:"10%",marginBottom:20}} />
                                            <h4 className="m-tb0">Construisons l'avenir ensemble.</h4>
                                        </div>
                                    </div>
                                    <div className="col-lg-8 col-md-12	col-sm-12">
                                        <div>
                                        <img src={photo} style={{border:1,width:100,height:100, borderRadius:"50%",marginBottom:20}} />
                                      <p>  <strong> CEO de ACE , Ingénieur En Génie Civil </strong> </p>
                                        </div>
                                        <div className="large-title-info">
                                            <p>Avec notre expertise en génie civil et votre vision, nous façonnons un monde meilleur, où chaque construction est une étape vers un avenir plus prometteur et durable.</p>
                                            <img src={sign} style={{height:50,float:'right' ,marginBottom:20}} />

                                            <div className="text-left" >
                                                <NavLink to={"/team-single"} className="site-button-secondry ">Lire Plus</NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default WhatWeDo1;